// Search text without case or Vietnamese accents, so "nguyen" finds "Nguyễn" and "hoa" finds both "Hóa" and "Hoá".
export function foldText(text: string) {
    return (text ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}

// Every word of the query appears somewhere in the haystack, in any order.
export function matchesQuery(haystack: string, query: string) {
    const words = foldText(query).split(' ').filter(Boolean);
    if (words.length === 0) return true;
    const folded = foldText(haystack);
    return words.every(word => folded.includes(word));
}
